// Tenant sozlamalari — BRAUZERDA saqlangan ESKI zaxira. ENDI FAQAT O'QILADI.
//
// ⚠️ YOZISH YO'LI OLIB TASHLANDI. Backend endi `GET /api/me` da
// `tenant.currency` va `tenant.dayTimezone` ni haqiqatan qaytaradi, tenant
// sozlamalari uchun esa `GET/PUT /api/tenant-settings` bor — ya'ni qiymat
// serverda saqlanadi va hamma xodimga bir xil ko'rinadi. Brauzerga yozish
// aynan buni buzardi: bitta operator o'zining brauzerida boshqa valyuta
// tanlab qo'yishi mumkin edi.
//
// O'qish qoldirildi: eskiroq brauzerlarda allaqachon saqlangan tanlov bor
// va server qiymat bermagan holatda (eski backend) u hali ham yagona
// manba. Server qiymati HAR DOIM ustun (`authApi.ts`).
//
// ⚠️ NEGA BU FAYL UMUMAN PAYDO BO'LGAN (o'sha paytdagi kontrakt bo'shlig'i):
// panel tenantning VALYUTASINI bilishi shart — pul minor birlikda keladi va
// uni ko'rsatish uchun ISO 4217 kodi kerak. Kod esa `platform.tenant`
// jadvalida bor (`TenantRegistry.Tenant` yozuvida `currency`, `dayTimezone`,
// `name`, `businessKind`), lekin HECH QAYSI endpoint uni bermaydi:
//
//   GET /api/me → {"userId","tenantId","username","permissions","scopes"}
//
// Ya'ni `tenantId` bor, tenant haqidagi ma'lumot yo'q. Tenant sozlamalari
// uchun alohida controller ham yo'q (`settings.read` huquqi mavjud, uni
// tekshiradigan endpoint yo'q).
//
// Shuning uchun: `/api/me` valyutani bergan zahoti u USTUN bo'ladi
// (`authApi.ts` sxemasi buni allaqachon qabul qiladi), gacha esa operator
// Sozlamalar sahifasida qo'lda tanlaydi va tanlov shu yerda saqlanadi.
//
// Tenant bo'yicha KALITLANGAN: bitta brauzerda `af-isp` (AFN) va `uz-venue`
// (UZS) ga navbatma-navbat kirilsa, umumiy kalit ikkinchisining valyutasini
// birinchisiga ko'rsatardi.

const PREFIX = 'xsib.tenant.'

export interface TenantPrefs {
  /** ISO 4217, masalan "AFN" */
  currency?: string
  /** IANA zonasi — hozircha faqat ko'rsatish uchun */
  timezone?: string
}

function keyOf(tenantId: string): string {
  return `${PREFIX}${tenantId}`
}

export function getTenantPrefs(tenantId: string): TenantPrefs {
  try {
    const raw = localStorage.getItem(keyOf(tenantId))
    if (!raw) return {}
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null) return {}
    const { currency, timezone } = parsed as Record<string, unknown>
    return {
      ...(typeof currency === 'string' ? { currency } : {}),
      ...(typeof timezone === 'string' ? { timezone } : {}),
    }
  } catch {
    // Buzilgan yozuv panelni to'xtatmasin — standart qiymatga qaytamiz
    return {}
  }
}
